import React from "react";

export default function WeatherForecastDay(props) {
  function day() {
    let date = new Date(props.data.time * 1000);
    let day = date.getDay();
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    return days[day];
  }

  return (
    <div>
      <div className="WeatherForecast-Day">{day()}</div>
      <img
        src={props.data.condition.icon_url}
        alt={props.data.condition.icon}
        className="WeatherForecastIcon"
      />
      <div className="WeatherForecastTemperatures">
        <span className="WeatherForecastTemperatureMax">
          {Math.round(props.data.temperature.maximum)}°
        </span>
        <span className="WeatherForecastTemperatureMin">
          {Math.round(props.data.temperature.minimum)}°
        </span>
      </div>
    </div>
  );
}
